export default __webpack_public_path__ + "static/7-list-articles-9befa92e91a330fc93b6d14c754d8dd0.jpg";